import React, {  Component } from 'react';
import { connect } from 'react-redux';
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';

const SortableItem = SortableElement(({index, item, pageNumber, onRemove}) =>
	<div className="productItem">
		<div className="sku">{item.productNumber}</div>
		<div className="remove">
			<a className="remove" href="" onClick={(e) => onRemove(item.productNumber, e)}>×</a>
		</div>
	</div>
);

const SortableList = SortableContainer(({items, pageNumber, onRemove}) => {
	return (
		<div className="productsContainer sortable">
			{items.map((item, index) => {
				return <SortableItem
					key={`item-${index}`}
					item={item}
					pageNumber={pageNumber}
					index={index}
					onRemove={onRemove}
				/>
			})}
		</div>
	);
});

class SortableComponent extends Component {
	constructor(props) {
        super(props);
        this.onSortEnd = this.onSortEnd.bind(this);
    }
	onSortEnd({oldIndex, newIndex}, event) {
		var self = this,
			updatedSequenceProducts = arrayMove(self.props.items, oldIndex, newIndex);
		updatedSequenceProducts.map((item, index) => {
			item.sequence = index + 1;
			return null;
		});
		self.props.sortEndOfProducts(updatedSequenceProducts, self.props.pageNumber, event);
	}
	remove(productNumber, event) {
		this.props.handleRemoveItemFromPage(this.props.pageNumber, productNumber, event)
    }
	shouldCancelStart(e) {
		// Prevent sorting from being triggered if target is input or button
		if (['a', 'button'].indexOf(e.target.tagName.toLowerCase()) !== -1) {
			return true; // Return true to cancel sorting
		}
    }
	render() {
		return <SortableList
      		items={this.props.items}
			onSortEnd={this.onSortEnd}
			pageNumber={this.props.pageNumber}
			shouldCancelStart={this.shouldCancelStart}
			onRemove={this.remove.bind(this)}
      	/>
	}
}

const mapStateToProps = (state) => {
	return {state};
};

SortableComponent = connect(mapStateToProps)(SortableComponent);
export default SortableComponent;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Brochure/productSortable.js